/* NUOMA 3.7.2 — Code promo dans le panier latéral.
   Le code est appliqué directement au panier Shopify : il est donc déjà pris en compte
   au moment de payer, y compris avec Apple Pay, Google Pay, Shop Pay ou PayPal. */
(() => {
  const box = document.querySelector('[data-nuoma-promo]');
  if (!box || !window.fetch) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const form = box.querySelector('[data-promo-form]');
  const input = box.querySelector('[data-promo-input]');
  const msg = box.querySelector('[data-promo-msg]');
  const applied = box.querySelector('[data-promo-applied]');
  const details = box.querySelector('details');
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: currency || 'EUR'}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  const say = (text, error) => { msg.textContent = text || ''; msg.classList.toggle('is-error', !!error); msg.hidden = !text; };

  function activeCodes(cart) {
    return (cart.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code);
  }
  function paint(cart) {
    if (!cart) return;
    const codes = activeCodes(cart);
    if (!codes.length) { applied.hidden = true; applied.replaceChildren(); return; }
    const total = (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + (Number(d.total_allocated_amount) || 0), 0)
      || (cart.items || []).reduce((sum, i) => sum + (Number(i.total_discount) || 0), 0);
    applied.replaceChildren();
    codes.forEach(code => {
      const row = document.createElement('div'); row.className = 'nuoma-promo__chip';
      const label = document.createElement('span');
      label.textContent = 'Code ' + code + (total ? ' · −' + money(total, cart.currency) : '');
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'nuoma-promo__remove';
      remove.textContent = 'Retirer'; remove.setAttribute('aria-label', 'Retirer le code ' + code);
      remove.addEventListener('click', () => apply(''));
      row.append(label, remove); applied.append(row);
    });
    applied.hidden = false;
  }
  async function getCart() {
    const r = await fetch(root() + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
    return r.ok ? r.json() : null;
  }
  async function apply(code) {
    const button = form.querySelector('button');
    button.disabled = true; say(code ? 'Vérification du code…' : '');
    try {
      const r = await fetch(root() + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({discount: code})
      });
      if (!r.ok) throw new Error();
      let cart = await r.json();
      const entry = (cart.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      if (code && (!entry || entry.applicable === false)) {
        // Code inconnu ou non valable pour ce panier : on le retire pour ne pas bloquer le paiement.
        const clean = await fetch(root() + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({discount: ''})});
        if (clean.ok) cart = await clean.json();
        say('Ce code n’est pas valable pour ce panier.', true);
      } else if (code) {
        say('Code appliqué. Il sera déduit au paiement, même avec Apple Pay ou PayPal.');
        input.value = '';
        if (details) details.open = false;
      } else {
        say('');
      }
      window.NuomaDrawerCart?.render?.(cart, {updated: true});
      paint(cart);
    } catch (_) {
      say('Impossible d’appliquer le code pour le moment. Vous pourrez le saisir à l’étape du paiement.', true);
    } finally {
      button.disabled = false;
    }
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    const code = (input.value || '').trim();
    if (!code) { say('Saisissez votre code.', true); input.focus(); return; }
    apply(code);
  });
  // Mise à jour de l'affichage quand le panier change (ajout, quantité, ouverture).
  const total = document.querySelector('[data-cart-total-price]');
  let timer;
  const sync = () => { clearTimeout(timer); timer = setTimeout(async () => paint(await getCart()), 150); };
  if (total) new MutationObserver(sync).observe(total, {childList: true, characterData: true, subtree: true});
  document.addEventListener('nuoma:drawer:open', sync);
  sync();
})();
